import { render, staticRenderFns } from "./LiveButton.vue?vue&type=template&id=71bf205e&scoped=true"
import script from "./LiveButton.vue?vue&type=script&lang=js"
export * from "./LiveButton.vue?vue&type=script&lang=js"
import style0 from "./LiveButton.vue?vue&type=style&index=0&id=71bf205e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf205e",
  null
  
)

export default component.exports